var _defs, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArgumed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326.3414 102.8908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.014em;}.cls-2{letter-spacing:0em;}.cls-3{fill:current;font-family:PoynterOSDisp-Semibold, PoynterOSDisp;font-size:74.6174px;font-weight:600;}.cls-4{letter-spacing:.013em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(9.7212 74.67)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 54.0229,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 83.7954,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 123.415,
    y: 0
  }, "umed"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgumed);
export default __webpack_public_path__ + "static/media/Argumed.5b5552fbcde7afdc89b956fdeeaf2035.svg";
export { ForwardRef as ReactComponent };